import React, { useState, useRef, useEffect } from "react";
import { IonApp, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonMenu, IonMenuToggle, IonPage, IonRadio, IonRadioGroup, IonTitle, IonToolbar } from '@ionic/react';
import topics from "../../menus/LKG/Mathematics";
import { Helmet } from "react-helmet";

const Mathematics: React.FC = () => {

    const handleSubmit = (url: string) => {
        window.location.href = url;
    }

    useEffect(() => {
        document.title = "Mamas Guidance - LKG - Mathematics"; // Set page title
    }, []);

    return (
        <>
            <Helmet>
                <meta name="description" content='Explore fun and interactive mathematics activities for LKG students on Mama’s Guidance—covering Pre Math Concepts, Counting Number, Missing Number, Skip Counting, Accending Decending Number, Pattern, Shapes, Ordinal Numbers through engaging worksheets and games designed to build early math confidence.' />
            </Helmet>
            <div className={`my-topic-container`}>
            {topics.map((slide, index) => (
                <IonItem key={index} routerLink={slide.url}
                    routerDirection="none"
                    lines="none"
                    detail={true}>
                    <IonLabel>{slide.title}</IonLabel>
                </IonItem>
            ))}
        </div>
        </>
    );
};
export default Mathematics;